import React, { useEffect } from "react";
import AboutCompanyRight from "../../assets/about-right-img.jpeg";
import "./index.css";
import { GiStairsGoal } from "react-icons/gi";
import { SiGooglesearchconsole } from "react-icons/si";
import  imageT  from "../../assets/WWA1.png";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import ButtonArrowImg from "../../assets/button-arrow-base.png";
import Formborder from "../../assets/contact-border.png";
import ClientOne from "../../assets/c1.png";
import ClientTwo from "../../assets/c2.png";
import ClientThree from "../../assets/c3.png";
import ClientFour from "../../assets/c4.png";
import ClientFive from "../../assets/c5.svg.png";
import ClientSix from "../../assets/c6.svg.png";
import ClientSeven from "../../assets/c7.png";
import ClientEight from "../../assets/c8.svg.png";
import ClientNine from "../../assets/c9.png";
import ClientTen from "../../assets/c10.png";
import ClientEleven from "../../assets/c11.jpg";
import ClientTwelve from "../../assets/c12.png";



const allImages = [
  {
    name: "CS",
    image: ClientSix,
  },
  {
    name: "CT",
    image: ClientTwo,
  },
  {
    name: "CO",
    image: ClientOne,
  },
  {
    name: "CTH",
    image: ClientThree,
  },
  {
    name: "CF",
    image: ClientFour,
  },
  {
    name: "CFI",
    image: ClientFive,
  },
  {
    name: "CSE",
    image: ClientSeven,
  },
  {
    name: "CE",
    image: ClientEight,
  },
  {
    name: "CN",
    image: ClientNine,
  },
  {
    name: "CTE",
    image: ClientTen,
  },
  {
    name: "CEL",
    image: ClientEleven,
  },
  {
    name: "CTW",
    image: ClientTwelve,
  },
];


const AboutCompany = ({heading , headingS}) => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [AboutCompany]);


  return (
    <div className={`container mx-auto ${heading ? "md:py-[60px] py-[30px]" : "pt-[26px]"}  px-6 md:px-12 text-justify `}>
      <div className="lg:grid grid-cols-2  gap-10 justify-between items-center">
        <div className={`flex-inline ${headingS ? "order-last" : ""}`}>
      
          <div>
          <p className="xl:text-[35px] lg:text-3xl md:text-[26px] text-[22px] font-serif  font-bold max-[770px]:text-center pb-2">
            What We're All About
          </p>
          <p className={`xl:text-xl lg:text-lg text-lg ${headingS ? "py-4" : "py-2"}  text-slate-500`}>
          PBX Technologies Inc. established in 2021, primarily offers telecom services, specializing in the construction, maintenance, inspection, and engineering of towers, as well as providing design solutions for point-to-point wireless, 5G deployment, and fiber optic installations.
              </p>
              {headingS &&
              <div classname=" flex items-center justify-center mb-10">
                <div className="flex">
              <div className="relative inline-block   max-[1024px]:m-auto">
              <Link to="/about">
                <button className="bg-[#FF366B]  text-white font-normal sm:py-[15px] sm:px-[40px] py-[10px] px-[30px] border-none rounded-[15px] buttonAnim before:border-[#ff366b]">
                  Learn More
                </button>
                <motion.div
                className="absolute top-0 right-[-75px]"
                initial={{ y: 0 }}
                animate={{ y: -10 }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                  repeatType: "reverse",
                }}>
                <img src={ButtonArrowImg} alt="button arrow base" />
              </motion.div>
              </Link>
              </div>             
            </div>
            </div>}
              </div>  
         
          
          {heading  && <> 
            <p className={`xl:text-xl lg:text-lg text-lg ${headingS ? "py-4" : "py-2"}  text-slate-500`}>
            We are ISO 9001:2015 certified, reflecting our unwavering commitment to quality in everything we do. From the moment a project begins to the final delivery, we ensure every detail meets the highest international standards. It’s this commitment to excellence that sets us apart and guarantees exceptional results for our clients.  
              </p>
              <p className={`xl:text-xl lg:text-lg text-lg ${headingS ? "py-4" : "py-2"}  text-slate-500`}>
              We’re not just another service provider—we’re innovators. With over 10 years of experience in the telecommunications space, we offer solutions that are tailored, scalable, and future-focused. Whether it’s for telecom carriers, enterprises, or businesses looking to enhance their IT infrastructure, we bring the expertise needed to navigate today’s complex technology landscape.
              </p>
         
          </>}
        
        </div>
        {heading  && 
        <div>
          <img
            src={AboutCompanyRight}
            className="md:h-[600px] w-auto max-[1024px]:mx-auto  lg:float-right max-[1024px]:px-4"
            alt="about-right-img "></img>
             
        </div>}
       {headingS && <div  className="rounded-tl-[30%] ring-offset-gray-500 relative  max-lg:mt-10 max-sm:mt-4"> <img src={imageT}  className="rounded-tl-[30%] rounded-tr-[70%] rounded-br-[70%] rounded-bl-[30%] m-auto sm:h-[450px] h-[300px] max-sm:pt-6"/> 
       <div
              className="absolute -z-50 left-24 -top-4  w-[65%] max-md:hidden wwaBorder"
            /></div>}
        
      </div>
     {heading &&       <div className="xl:text-xl lg:text-lg text-lg lg:py-0 pt-6  text-slate-500 ">
            PBX Technologies collaborates with clients,communities, and
            coworkers to design and implement novel solutions to
            telecommunication technical challenges so the highest quality
            services can be delivered to our customers. Clients across Canada
            can depend on our abilities to design, manage and execute their
            projects.
            <br/>
            PBX Technologies is a trained and skilled team of Telecom Technicians,
            Tower Riggers, Fiber splicers, linemen and equipment operators.
            <br/>
            <br/>
        
            <div className="flex items-center py-2">
            <div className="pr-4">
              <div className="relative">
                <div
                  className="origin-center rotate-45 sm:h-[50px] sm:w-[50px] h-[40px] w-[40px] bg-[#FF366B] sm:rounded-[20px] rounded-[15px]
              my-design  before:border-[#FF366B] before:border-2 before:top-[0px] before:left-[5px] before:h-[2.8em]  before:sm:h-[3.4em]">
                  <GiStairsGoal
                    className="absolute z-10 rotate-[315deg] top-[20%] sm:left-[25%] left-[20%]"
                    size={25}
                    color="#ffffff"
                  />
                </div>
              </div>
            </div>
            <div>
              <p className="font-bold text-black xl:text-xl lg:text-lg text-lg pb-2 ">
                Our Mission Statement
              </p>
              <p className=" text-slate-500 xl:text-xl lg:text-lg text-lg ">
                Our goal is to provide our customers with an unparalleled level
                of competence and a single point of contact for all of their
                project requirements
              </p>
               </div>
          </div>
          
          <br/> 


          <div className="flex items-center py-2">
            <div className="pr-4">
              <div className="relative">
                <div className="origin-center rotate-45 sm:h-[50px] sm:w-[50px] h-[40px] w-[40px] bg-[#1A28F6] sm:rounded-[20px] rounded-[15px]  my-design before:border-[#1A28F6] before:border-2 before:top-[0px] before:left-[5px] before:h-[2.8em]  before:sm:h-[3.4em] !important">
                  <SiGooglesearchconsole
                    className="absolute rotate-[315deg] z-10 top-[20%] sm:left-[20%] left-[20%]"
                    size={25}
                    color="#ffffff"
                  />
                </div>
              </div>
            </div>
            <div>
              <p className="font-bold xl:text-xl lg:text-lg text-lg pb-2 text-black ">
              Safety & Sustainability—Our Core Values
              </p>
              <p className=" text-slate-500 xl:text-xl lg:text-lg text-lg ">
              At PBX Technologies, safety and sustainability aren’t just buzzwords; they are integral to how we operate. As proud partners of industry-leading compliance companies , we uphold the strictest environmental, health, and safety standards. Whether on-site or in the office, we prioritize the well-being of our people and the communities we serve. This dedication ensures that we not only meet but exceed industry expectations for responsible operations.
              </p>
            </div>
            
          </div>

          <br/>

<div className="w-full">
  {/* First Row */}
  <div className="relative w-full">
  <div className="polygon-bg w-full">
    <div className="flex justify-center items-center py-8">
      <h1 className="xl:text-[35px] lg:text-3xl md:text-[26px] text-[22px] font-serif font-bold max-[770px]:text-center pb-2 text-white">
        Trusted By
      </h1>
    </div>
  </div>
</div>


  {/* Second Row */}
  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-x-5 gap-y-8 py-8 w-full">
  {allImages.map((imageObj) => (
    <div
      key={imageObj?.name}
      className="w-[8rem] h-[8rem] mx-auto flex items-center justify-center bg-white  rounded"
    >
      <img
        alt={imageObj?.alt || imageObj?.name || "Image"}
        src={imageObj?.image}
        className="max-w-full max-h-full object-contain"
      />
    </div>
  ))}
</div>

</div>

       </div>}
    </div>
  );
};

export default AboutCompany;
